<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "nilkan-liikkuvuus-ja-huolto-osa1";
    let title = "Nilkan liikkuvuus ja huolto, osa 1";
    let author = "Petteri";
    let blogDate = "1.10.2016";
    let titlePic = "nilkat.jpg";
    let firstPara = "Nivelillämme on tärkeä rooli liikkuvuuden ja stabiliteetin tarjoajana. Ongelmat nilkan liikkuvuudessa heijastuvat ylöspäin ja voivat oireilla jopa rintarangassa ja niskassa asti.";

    let articleLink1 = "01";
    let articleLink2 = "02";
    let articleLink3 = "15";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>Oletko koskaan ajanut autolla jossa on nelikulmaiset pyörät? <a href="https://youtu.be/CIN8Q_4iaxU" target="_blank">Myytinmurtajat testasivat asiaa</a> ja 
                lopputulema oli ennakoitavissa. Autolla pääsi kyllä etenemään, mutta koko hökötys tärisi enemmän 
                kuin perusperheen pyykkikone. Miten pitkään luulet auton kestävän moista höykytystä? 
                Todennäköisesti vikoja alkaisi piankin ilmenemään aina pakoputken kiinnityksestä lamppujen toimintaan.</p>

            <p>Kehomme ei ole tässä asiassa niinkään erilainen. Nivelillämme on vuorottain rooli liikkuvuuden ja
                stabiliteetin tarjoajina. Nilkoillamme on tärkeä tehtävä olla ensimmäinen liikkuvuuden tarjoaja. 
                Jos ne on jäykistyneet eivätkä tarjoa riittävää liikkuvuutta,
                täytyy muiden kehomme osien ottaa koppia nilkan tehtävästä. Tuloksena on että iskunvaimentimien
                (jalkaterä, polvet ja lonkka), rungon (selkäranka) sekä lopulta jopa korin (rintaranka) on kompensoitava
                nilkan toimimattomuutta jokapäiväisessä elämässä. Mikäli jäykistettyyn nilkkaan ei kiinnitettäisi mitään huomiota,
                ja lisäisimme vain kaasua, alkaisi nämä muut nilkan roolin ottaneet jäsenet oireilla vääränlaisesta
                kuormituksesta. Ylläripylläri, kehomme on kokonaisuus. Kun homma etenee sähkövikoihin (hermosto) saakka
                alkaa olla jo tosi kyseessä. Paalutettavaksi ei kannata kuitenkaan vielä mennä sillä peliä ei ole vielä
                menetetty.</p>

            <h4>Nilkan liikkuvuudesta</h4>

            <p>Liikkuvana nivelenä nilkalla on todella tärkeä rooli niin kyykkyliikkeissä kuin myös juoksussa ja
                kävelyssä. Kävelyssä nilkkaan tarvitaan noin 10 asteen liikkuvuus. Aste lähdetään laskemaan
                neutraaliasennosta dorsifleksioon eli kun kurotat varpaita lähemmäksi polvia. Vajaalla liikeradalla
                ongelmia voi ilmetä jalkapohjassa sekä polvessa varsinkin juoksun harrastajilla.</p>

            <p>Toinen tärkeä rooli liikkuvuudella on hyvän kyykkyasennon saavuttaminen. En lähde tässä tekstissä käymään
                lävitse kyykkyä tarkemmin, mutta kyseessä on asento jota jokaisen tulisi vaalia vauvasta vaariin. Sitä
                ei turhaan sanota yhdeksi kolmesta ihmisen perusasennosta. Toiset kaksi on seisominen ja makaaminen.</p>

            <img src="/svelte-site/img/blog/oskar-787x800.jpg" alt="Lapselle kyykky on luonnollinen asento"
                 width="400" height="407"/>
            <p class="kuvateksti">Lapselle kyykky on luonnollinen asento (Oskar 1,5 v ja "puhelin")</p>

            <p>Kyykkyliikkeeseen osallistuu yli 200 lihasta joten kyseessä lienee yksi tärkein ja kokonaisvaltaisin
                liike mitä voimme tehdä. Mitä laajemmalla liikelaajuudella kyykkyä teemme, sitä useampi lihas
                liikkeeseen osallistuu ja sitä tehokkaampi liikkeestä tulee. Mitä liikkuvampia nilkat ovat, sitä
                pystymmässä asennossa voimme keskivartaloamme pitää kyykkyyn mentäessä. Polvi voi siis mennä reilustikin
                varvaslinjan ohitse. Ilman nilkan hyvää liikkuvuutta pyrkivät kantapäät nousemaan maasta kyykkyyn
                mentäessä. Kyykystä tulee myös hyvin etupainotteinen, jolloin kyykkääjä ei pääse aktivoimaan pakaroita
                eikä takareisiä liikkeessä niin hyvin.</p>

            <img src="/svelte-site/img/blog/etu_ja_takakyykky-800x384.png" alt="Taka ja etukyykky" />
            <p class="kuvateksti">Partapetterin taka- ja etukyykky</p>

            <h4>Jumi tuli yllättäen ja pyytämättä. Vai tuliko?</h4>

            <p>Nilkan ja yleensäkin nivelien liikkuvuus voi häiriintyä monestakin syystä. Ensimmäinen ja ehkä se
                odotetuin on jäykistyminen iän myötä. On olemassa sanonta “use it or lose it” joka pätee kehomme
                kaikkiin alueisiin. Mikäli emme aktiivisesti vaali näitä ääriasentoja, tottuu kehomme uuteen malliin ja
                pikkuhiljaa jäykistää niin sanotut turhat alueet pois käytöstä. Voimme myös kannustaa kehoamme
                lyhentämään liikelaajuttamme käyttämällä esimerkiksi korkokenkiä tai muuten tukevia kenkiä liikaa.
                Korkokenkien kanssa pohje on lyhennetyssä tilassa pitkiä aikoja, mikä aiheuttaa ennen pitkää pysyviä
                ongelmia nilkan liikkuvuudelle. Parasta olisi läpsytellä valtaosa ajasta ilman minkäänlaisia kenkiä.</p>

            <p>Myös erilaiset vammat voivat rustouttaa ja rajoittaa nilkan liikkuvuutta. Vammojen jälkeen nilkka tulisi
                kuntouttaa mahdollisimman pian ennen kuin tilanne kroonistuu. Vammojen jälkeen keho yrittää adaptoitua
                uuteen tilanteeseen ja lähtee kompensoimaan uutta liikemalleja muiden kehon osien avulla.</p>

            <h4>Kehonhuollon muita hyötyjä</h4>

            <p>Säännöllisellä kehonhuollolla ehkäistään paitsi edellä mainittuja tuki- ja liikuntaelinsairauksia, mutta
                myös parannetaan elimistön suorituskykyä. Palautuneessa ja terveessä lihaksessa ei ole jumeja ja
                verenkierto toimii normaalisti. Tämä tarkoittaa että aineenvaihdunta pelaa ja kuljettaa kuona-aineita
                pois lihaksesta.</p>

            <p>Elastinen lihas ei revähdä niin helposti äkillisistä äärimmilleen viedystä venytyksestä, kuten
                esimerkiksi liukastumisesta talvella. Jos ääriasento on keskushermostolle tuttu, ei kehon
                suojamekanismit vedä jarrua päälle niin herkästi. Kynän nostaminen lattialta ei pitäisi olla asia jonka
                seurauksena täytyy krampata selkälihakset rangan suojelemiseksi.</p>

            <p>Voit alkaa virittelemään jo tunkkia alle sillä kohta neliön malliset renkaat vaihdetaan pyöreisiin.
                Seuraavassa osassa käyn läpi nilkan liikkuvuustestejä sekä annan muutaman tipsin liikkuvuuden
                parantamiseksi. Toisin kuin autoissa, ei tämä vaihto-operaatio suju ihan niin nopeasti, mutta sinnikäs
                työ palkitaan ajallaan.</p>

            <p>--<br>
                Petteri</p>

            </article>


        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <!-- -->
                    <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen käyttöön' titlePic='2014/etunojapunnerrus2.jpg' blogDate='20.9.2014' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='ranteiden_huolto' title='Ranteiden liikkuvuus ja huolto' titlePic='ranne.jpg' blogDate='1.2.2015' firstPara='Ärtyneet ja kipeät ranteet vaivaavat nykyisin yhä useampaa ihmistä. Vaiva on yleistynyt samalla kun työnkuva on muuttunut enemmän paikallaan nöpöttämiseksi hiiren tai muun laitteen parissa. Lue tästä, mitä voit itse tehdä ranteidesi hyväksi ettei tilanne pahene ja kipu riistäytyy hallinnasta.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='nilkan-liikkuvuus-ja-huolto-osa2' title='Nilkan liikkuvuus ja huolto, osa 2' titlePic='nilkat-2.png' blogDate='2.10.2016' firstPara='Nilkkakirjotuksen toisessa osassa pääsemme mittaamaan nilkan nykyhetken tilanteen ja käärimään hihat liikkuvuusmörön nujertamiseksi.'></BlogSummary>
                </article>
            </div>
        </section>


    </div>
{/if}

<style>


</style>